import axios from "axios";
import { BASE_URL } from "../../constant";

import {
  handleFormatResponse,
  handleFormatResponseForError,
} from "../../utility";

const useStudentWorkingDays = () => {
     const fetchStudentWorkingData = async (endpoint: string) => {
    try {
      let response = await axios.get(
        `${BASE_URL}DashboardSchoolStudentsAttendance/${endpoint}`
      );
      // console.log("Response: ", response?.data);
      const formattedResponse = handleFormatResponse(response);
      return formattedResponse;
    } catch (error: any) {
      // console.log("Error: ", error);
      const formattedError = handleFormatResponseForError(error);
      return formattedError;
    }
  };

  const postStudentWorkingDataData = async (endpoint: string, payload: any) => {
    try {
      let response = await axios.post(
        `${BASE_URL}DashboardSchoolStudentsAttendance/${endpoint}`,
        payload
      );
      // console.log("Response: ", response?.data);
      const formattedResponse = handleFormatResponse(response);
      return formattedResponse;
    } catch (error: any) {
      // console.log("Error: ", error);
      const formattedError = handleFormatResponseForError(error);
      return formattedError;
    }
  };
  return {
    fetchStudentWorkingData,
    postStudentWorkingDataData,
  };
}

export default useStudentWorkingDays